export const accountTypesFilterState = () => ({
  page: 1,
  perPage: 1000,
});
